import type { ComponentProps } from 'react'
import * as React from 'react'
import { Marker } from 'react-map-gl/mapbox'

import type { LngLat } from 'lib/maps/types'

export interface MapboxMarkerProps extends Omit<ComponentProps<typeof Marker>, 'latitude' | 'longitude'> {
  coordinate: LngLat
}

export function MapboxMarker({ coordinate, anchor = 'bottom', ...props }: MapboxMarkerProps) {
  return (
    <Marker
      latitude={coordinate.lat}
      longitude={coordinate.lng}
      anchor={anchor}
      {...props}
    />
  )
}
